import { useMutation } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";

export const createQuoteFinanceComparisonView = (
  quoteId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { defaultOnMutateError, defaultOnMutateSuccess } = useAPQuery();

  return useMutation({
    mutationFn: (): Promise<string> => {
      return fetchWithAuth<string>(
        "createQuoteFinanceComparisonView",
        quoteId,
        {
          requestOptions: {
            method: "post",
          },
        }
      );
    },
    onError: defaultOnMutateError(options),
    onSuccess: defaultOnMutateSuccess(options),
  });
};
